import { databases, databaseId } from '../config/appwrite';
import { Feedback } from '../types';
import { Query } from 'appwrite';

const FEEDBACK_COLLECTION_ID = 'feedback';

export class FeedbackService {
  static async createFeedback(feedback: Omit<Feedback, 'id' | 'createdAt' | 'updatedAt'>): Promise<Feedback> {
    try {
      const response = await databases.createDocument(
        databaseId,
        FEEDBACK_COLLECTION_ID,
        'unique()',
        {
          authorName: feedback.authorName,
          feedback: feedback.feedback,
          articleId: feedback.articleId || null
        }
      );

      return {
        id: response.$id,
        authorName: response.authorName,
        feedback: response.feedback,
        articleId: response.articleId,
        createdAt: new Date(response.$createdAt),
        updatedAt: new Date(response.$updatedAt)
      };
    } catch (error) {
      console.error('Error creating feedback:', error);
      throw error;
    }
  }

  static async getAllFeedback(): Promise<Feedback[]> {
    try {
      const response = await databases.listDocuments(
        databaseId,
        FEEDBACK_COLLECTION_ID,
        [
          // Sortiere nach Erstellungsdatum, neueste zuerst
          Query.orderDesc('$createdAt')
        ]
      );

      return response.documents.map(doc => ({
        id: doc.$id,
        authorName: doc.authorName,
        feedback: doc.feedback,
        articleId: doc.articleId,
        createdAt: new Date(doc.$createdAt),
        updatedAt: new Date(doc.$updatedAt)
      }));
    } catch (error) {
      console.error('Error fetching feedback:', error);
      throw error;
    }
  }

  static async deleteFeedback(feedbackId: string): Promise<void> {
    try {
      await databases.deleteDocument(
        databaseId,
        FEEDBACK_COLLECTION_ID,
        feedbackId
      );
    } catch (error) {
      console.error('Error deleting feedback:', error);
      throw error;
    }
  }
}
